const SUPPORTED_CONNECTOR_IDS = new Set([
  'excel', 'csv', 'google_sheets', 'excel_online', 'salesforce', 'zoho', 'simulator', 'postgresql',
  'application_insights',
]);

export function getPickerConnectors<T extends { id: string; enabled: boolean }>(
  connectors: T[], production: boolean,
): T[] {
  return connectors.filter(connector =>
    connector.enabled && SUPPORTED_CONNECTOR_IDS.has(connector.id)
    && (!production || connector.id !== 'simulator'),
  );
}

export function getExpandedCategories(categories: { id: string }[]): Set<string> {
  return new Set(categories.map(category => category.id));
}